export default "__VITE_ASSET__e3i6a9CX__"